export default __webpack_public_path__ + "static/media/rightArrow.3ec6403c.svg";